import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var typePath = "spark.element.type";

var basePath = function basePath(name) {
  return "".concat(typePath, ".").concat(name);
};

var t = {
  headings: {
    fontWeight: '700',
    fontFamily: 'heading'
  },
  subtitles: {
    fontFamily: 'base'
  },
  bold: {
    fontWeight: '700'
  },
  buttons: {
    fontWeight: '900'
  },
  // Design want to have an extra large heading for occasional use
  H0: {
    variant: basePath('headings'),
    fontSize: ['xxl', 'xxxl', '4xl'],
    lineHeight: ['h_xxl', 'h_xxxl', 'h_4xl']
  },
  // These styles are set for default text formatting
  H1: {
    variant: basePath('headings'),
    fontSize: ['xl', 'xxl', 'xxxl'],
    lineHeight: ['h_xl', 'h_xxl', 'h_xxxl']
  },
  H2: {
    variant: basePath('headings'),
    fontSize: ['lg', 'xl', 'xxl'],
    lineHeight: ['h_lg', 'h_xl', 'h_xxl']
  },
  H3: {
    variant: basePath('headings'),
    fontSize: ['lg', 'xl', 'xl'],
    lineHeight: ['h_lg', 'h_xl', 'h_xl']
  },
  H4: {
    variant: basePath('headings'),
    fontSize: ['md', 'lg', 'lg'],
    lineHeight: ['h_md', 'h_lg', 'h_lg']
  },
  H5: {
    variant: basePath('headings'),
    fontSize: ['fg_md', 'md', 'md'],
    lineHeight: ['h_fg_md', 'h_md', 'h_md']
  },
  H6: {
    variant: basePath('headings'),
    fontSize: ['fg_md', 'md', 'md'],
    lineHeight: ['h_fg_md', 'h_md', 'h_md']
  }
};
export var typeStyles = {
  headings: t.headings,
  h1: _objectSpread(_objectSpread({}, t.H1), {}, {
    variant: 'styles.headings'
  }),
  h2: _objectSpread(_objectSpread({}, t.H2), {}, {
    variant: 'styles.headings'
  }),
  h3: _objectSpread(_objectSpread({}, t.H3), {}, {
    variant: 'styles.headings'
  }),
  h4: _objectSpread(_objectSpread({}, t.H4), {}, {
    variant: 'styles.headings'
  }),
  h5: _objectSpread(_objectSpread({}, t.H5), {}, {
    variant: 'styles.headings'
  }),
  h6: _objectSpread(_objectSpread({}, t.H6), {}, {
    variant: 'styles.headings'
  })
};
export default t;